var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content ht-100v pd-0"},[_c('main-header',{attrs:{"txt":"Осол саадын тоо"}}),_c('div',{staticClass:"content-body pd-0-f"},[_c('div',{staticClass:"container pd-0-f"},[_c('accident',{attrs:{"bd":"bd-0"}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }